
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-emerald-400 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Invirtiendo
            </h3>
            <p className="text-gray-300 mb-4 max-w-md">
              La plataforma inteligente que te ayuda a gestionar tus finanzas personales, 
              ahorrar e invertir con confianza para construir tu futuro financiero.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Producto</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Dashboard</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Análisis IA</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Proyecciones</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Reportes</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Soporte</h4>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Centro de Ayuda</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Contacto</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Términos</a></li>
              <li><a href="#" className="hover:text-emerald-400 transition-colors cursor-pointer">Privacidad</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 Invirtiendo. Todos los derechos reservados.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
